import { getCurrentInstance } from 'vue';

export default function useNovaCore() {
  const vue = getCurrentInstance();
  return vue.proxy.novaCore;
}
